<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 3H19.5858L25 8.41421V28H6V3Z" fill="var(--bg-color)" stroke="var(--icon-color)" stroke-width="2" />
    <path d="M9 7.5L14 7.5" stroke="var(--icon-color)" />
    <path d="M9 12.5H17" stroke="var(--icon-color)" />
    <path d="M19 12.5L22 12.5" stroke="var(--icon-color)" />
    <path d="M19 15.5L22 15.5" stroke="var(--icon-color)" />
    <path d="M19 18.5L22 18.5" stroke="var(--icon-color)" />
    <path d="M9 15.5H16" stroke="var(--icon-color)" />
    <path d="M9 18.5H13.6" stroke="var(--icon-color)" />
    <path d="M9 21.5H11" stroke="var(--icon-color)" />
    <path d="M9 23.5H12" stroke="var(--icon-color)" />
    <path
        d="M23.8929 30.1429C26.1612 30.1429 28 28.304 28 26.0357C28 23.7674 26.1612 21.9286 23.8929 21.9286C23.3087 21.9286 22.7531 22.0505 22.25 22.2703V29.8011C22.7531 30.0209 23.3087 30.1429 23.8929 30.1429Z"
        fill="var(--bg-color)" stroke="var(--icon-color)" />
    <circle cx="20.6071" cy="26.0357" r="4.10714" fill="var(--bg-color)" stroke="var(--icon-color)" />
    <circle cx="20.6071" cy="26.0358" r="1.96429" fill="var(--icon-color)" stroke="var(--icon-color)" />
</svg>
